module.exports = __webpack_public_path__ + "img/mit-Elektro.83c54a93.png";